import styled from '@emotion/styled';

export const Separator = styled.div<{ size?: number; vertical?: boolean }>`
  height: ${({ vertical, size = 1 }) => (vertical ? '100%' : `${size}px`)};
  width: ${({ vertical, size = 1 }) => (vertical ? `${size}px` : '100%')};
  background-color: #E2E6EB;
`;
